<template>
  <div>
    <apexchart
      :key="chartKey"
      type="donut"
      :options="chartOptions"
      :series="chartSeries"
      height="234px"
    ></apexchart>
  </div>
</template>
  
  <script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      required: true,
      default: () => [0, 0, 0],
    },
  },
  computed: {
    isZeroData() {
      return this.series.every(value => value === 0);
    },
    chartSeries() {
      return this.isZeroData ? [1] : this.series;
    },
    chartOptions() {
      return {
        chart: {
          type: "donut",
        },
        labels: this.isZeroData ? ["No Data Available"] : ["Success", "Failure","Dispute"],
        colors: this.isZeroData ? ["#bebfc1"] : ["#0c9c0c", "#cb1b1b","#BD52D1"],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: this.isZeroData ? false : true,
          formatter: () => "",
        },
        noData: {
          text: "No data available",
          align: "center",
          verticalAlign: "middle",
          style: {
            color: "#ccc",
            fontSize: "14px",
          },
        },
        tooltip: {
          enabled: this.isZeroData ? false : true,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 250,
              },
              legend: {
                position: "bottom",
                show: false,
              },
            },
          },
        ],
      };
    },
  },
};
</script>
